import { Typography } from '@mui/material';
import PriceComponent from 'components/PriceComponent';

function AccommodationFee({
  registrationFee: {
    accommodationFeeExchanded: feeExchanged,
    accommodationFeeWithDiscountExchanded: withDiscountExchanged,
  },
}) {
  if (Number.isNaN(feeExchanged || withDiscountExchanged)) return null;

  const hasDiscount = withDiscountExchanged < feeExchanged;

  const currentPrice = hasDiscount ? withDiscountExchanged : feeExchanged;

  return (
    <>
      {hasDiscount && (
        <Typography
          component="span"
          sx={{
            color: '#8a8a8a',
            marginRight: '8px',
            textAlign: 'right',
            textDecoration: 'line-through',
          }}
          variant="caption"
        >
          <PriceComponent value={feeExchanged} />
        </Typography>
      )}
      <Typography
        component="span"
        sx={{ textAlign: 'right', fontWeight: 900 }}
        variant="caption"
      >
        {currentPrice > 0 ? (
          <PriceComponent value={currentPrice} />
        ) : (
          <strong>GRÁTIS</strong>
        )}
      </Typography>
    </>
  );
}

export default AccommodationFee;
